import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}
export const SharedAccountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFamily: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
    
      }
    >({
      query: ({ length, search, start}) => ({
        url: `${END_POINTS.getFamily}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getFamilyById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getFamilyById}${id}/`,
        method: "GET",
      }),
    }),
    updateFamily: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateFamily}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteFamily: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFamily}${id}/`,
        method: "DELETE",
      }),
    }),
    unlinkFamily: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.unlinkFamily}${id}/`,
        method: "DELETE",
      }),
    })
  }),
});

export const {
useLazyGetFamilyQuery,
useLazyGetFamilyByIdQuery,
useUpdateFamilyMutation,
useDeleteFamilyMutation,
useUnlinkFamilyMutation
} = SharedAccountApi;
